import { render, staticRenderFns } from "./ProductSoldByCategoryPage.vue?vue&type=template&id=1eac2da6&scoped=true&"
import script from "./ProductSoldByCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ProductSoldByCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductSoldByCategoryPage.vue?vue&type=style&index=0&id=1eac2da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eac2da6",
  null
  
)

export default component.exports